import { useEffect, useRef, useState } from 'react'
import { Box, Button, Select, MenuItem, FormControl, InputLabel, CircularProgress } from '@mui/material'
import Tooltip from '@mui/material/Tooltip';
import ScaleIcon from '@mui/icons-material/Scale';
import RefreshIcon from '@mui/icons-material/Refresh';
import IconButton from '@mui/material/IconButton';
import { sendInferenceRequest, AddCustomVarietes, getCropsAndVarieties, getAllMachine, getCompanyMetaData, getRequestConfigurations } from '../../utils/api'
import { generateTimeBasedUniqueScanId } from '../../utils/utils'
import WeightAndMoisture from './WeightAndMoisture'
import AddCustomVariety from './AddCustomVariety'
import ResultScreen from './ResultScreen'
import PopUpMessage from '../../components/PopUpMessage'
import ProcessingForm from './ProcessingForm';
// import Slider from '@mui/material/Slider';
// import InfoIcon from '@mui/icons-material/Info';
// import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
// import Paper from '@mui/material/Paper';
import DropDown from '../../components/DropDown';
import { getThresholdValues } from '../../utils/staticThresholdValue';
import { GetScanResultMerged } from '../../utils/utils';

const ACCENT_BLUE = '#22638f';
const ACCENT_ORANGE = '#d96c3c';
const TEXT_MUTED = '#93a0b5';
const TEXT_BODY = '#3b4a63';
const BORDER = '#eef2f8';

const cardShell = {
  borderRadius: '16px',
  boxShadow: '0 2px 10px rgba(12, 61, 110, 0.05)',
  border: `1px solid ${BORDER}`,
};

// Reusable styled file input — matches DropDown/theme look instead of raw browser chrome
function FileField({ label, required, inputRef, onChange, multiple = false, fullWidth = false }) {
  return (
    <Box sx={{ width: fullWidth ? '100%' : 'auto' }}>
      <div style={{ fontSize: 13, color: TEXT_BODY, marginBottom: 6, fontWeight: 600 }}>
        {label}{required && <span style={{ color: 'red' }}> *</span>}
      </div>
      <Box
        sx={{
          width: fullWidth ? '100%' : 210,
          height: 40,
          display: 'flex',
          alignItems: 'center',
          borderRadius: '10px',
          border: `1px solid ${BORDER}`,
          backgroundColor: '#fff',
          px: 1,
          '& input[type="file"]': {
            fontSize: 12.5,
            color: TEXT_MUTED,
            width: '100%',
          },
          '& input[type="file"]::file-selector-button': {
            border: 'none',
            borderRadius: '6px',
            padding: '6px 10px',
            marginRight: 8,
            backgroundColor: 'rgba(34, 99, 143, 0.08)',
            color: ACCENT_BLUE,
            fontSize: 12,
            fontWeight: 600,
            cursor: 'pointer',
          },
        }}
      >
        <input
          type="file"
          accept="image/*"
          multiple={multiple}
          required={required}
          className="cursor"
          onChange={onChange}
          ref={inputRef}
        />
      </Box>
    </Box>
  );
}

export default function Dashboard() {
  const company_id = localStorage.getItem("company_id");
  const user_id = localStorage.getItem("user_id");
  const allowedExtensions = ['jpg', 'jpeg', 'png', 'webp', 'bmp', 'svg'];
  const fileInputRef = useRef(null);
  const bottomFileInputRef = useRef(null);
  const [crops, setCrops] = useState([])
  const [uniqueCropList, setUniqueCropList] = useState([])
  const [verietyListRelatedCrop, setVarietyListRelatedCrop] = useState([])
  const [machines, setMachines] = useState([])
  const [getUserMetaData, setGetUserMetaData] = useState([])
  const [selectedCrop, setSelectedCrop] = useState('')
  const [selectedVariety, setSelectedVariety] = useState('')
  const [selectedCapturedWebpImage, setSelectedCapturedWebpImage] = useState([])
  const [selectedCapturedWebpImageBottom, setSelectedCapturedWebpImageBottom] = useState('')
  const [selectedMachine, setSelectedMachine] = useState('')
  const [isLoadingRequestConfigurations, setIsLoadingRequestConfigurations] = useState(false)
  const [scanId, setScanId] = useState(null)
  const [totalSubScan, setTotalSubScan] = useState(null)
  const [scanData, setScanData] = useState(null)
  const [isProcessing, setIsProcessing] = useState(false)
  const [processedImage, setProcessedImage] = useState([]);
  const [processedImageBottom, setProcessedImageBottom] = useState(null);
  const [title, setTitle] = useState('')
  const [message, SetMessage] = useState('')
  const [isMessageOpen, setIsMessageOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isErrorOpen, setIsErrorOpen] = useState(false)
  const [isAddMoistureAndWeight, setIsAddMoistureAndWeight] = useState(false)
  const [weight, setWeight] = useState('')
  const [moisture, setMoisture] = useState('')
  const [requestConfigurations, setRequestConfigurations] = useState(null)
  const [visiblePDfButton, setVisiblePdfButton] = useState(false)
  const [isMetaDataServerResponce, setIsMetaDataServerResponce] = useState('')
  const [isCvInferenceResponce, setIsCvInferenceResponce] = useState(false)
  const [updatedUserMetaData, setUpdatedUserMetaData] = useState('')
  const [chalkyArea, setchalkyArea] = useState(50);
  const [discolorArea, setdiscolorArea] = useState(10);
  const [chalkyQuality, setchalkyQuality] = useState(50);
  const [discolorQuality, setdiscolorQuality] = useState(20);
  // const [anchorEl, setAnchorEl] = useState(null);
  // const [anchorForDiscolor, setAnchorForDiscolor] = useState(null);
  // const [openChalky, setOpenChalky] = useState(false);
  // const [openDiscolor, setOpenDiscolor] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [heightOfKernel, setHeightOfKernel] = useState('');
  const [poniyaThreshold, setPoniyaThreshold] = useState('');
  const [brokenThreshold, setBrokenThreshold] = useState('');
  const [addThreshold, setAddThreshold] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const [chalkyAreaForVariety, setchalkyAreaForVariety] = useState(50);
  const [discolorAreaForVariety, setdiscolorAreaForVariety] = useState(10);
  const [chalkyQualityForVariety, setchalkyQualityForVariety] = useState(50);
  const [discolorQualityForVariety, setdiscolorQualityForVariety] = useState(20);
  const [selectedValues, setSelectedValues] = useState({});
  const [isMultiCapture, setIsMultiCapture] = useState(false);
  const [selectedLedTopImage, setSelectedLedTopImage] = useState(null);
  const [selectedLedBottomImage, setSelectedLedBottomImage] = useState(null);
  const ledTopFileInputRef = useRef(null);
  const ledBottomFileInputRef = useRef(null);

  const handleSelectChange = (keyName, value) => {
    setSelectedValues(prevState => ({
      ...prevState,
      [keyName]: value,
    }));
  };

  const handleCheckboxChange = () => {
    setAddThreshold(!addThreshold);
  };

  // const handleButtonClick = (event) => {
  //   setOpenChalky(true);
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleButtonClickForDiscolor = (event) => {
  //   setOpenDiscolor(true)
  //   setAnchorForDiscolor(event.currentTarget);
  // };

  useEffect(() => {
    setValuesFromVariety(selectedVariety?.variety_name);
  }, [selectedVariety]);

  function setValuesFromVariety(variety) {
    if (variety?.includes("_a") && variety.includes("_b") && variety.includes("_c") && variety.includes("_d")) {
      let aMatch = variety.match(/_a(\d+)/);
      let bMatch = variety.match(/_b(\d+)/);
      let cMatch = variety.match(/_c(\d+)/);
      let dMatch = variety.match(/_d(\d+)/);
      if (aMatch) {
        setchalkyArea(parseInt(aMatch[1]));
      }

      if (bMatch) {
        setchalkyQuality(parseInt(bMatch[1]));
      }

      if (cMatch) {
        setdiscolorArea(parseInt(cMatch[1]));
      }

      if (dMatch) {
        setdiscolorQuality(parseInt(dMatch[1]));
      }
    } else {
      setchalkyArea(50);
      setdiscolorArea(10);
      setchalkyQuality(50);
      setdiscolorQuality(20)
    }
  }

  const resetSliders = () => {
    setchalkyArea(50);
    setdiscolorArea(10);
    setchalkyQuality(50);
    setdiscolorQuality(20)
  };
  // const handleClose = () => {
  //   setAnchorEl(null);
  //   setOpenChalky(false);
  // };
  // const handleCloseForDiscolor = () => {
  //   setAnchorForDiscolor(null);
  //   setOpenDiscolor(false);
  // };
  // const handleSliderforChalkyArea = (event, newValue) => {
  //   setchalkyArea(newValue);
  // };
  // const handleSliderForChalkyQuality = (event, newValue) => {
  //   setchalkyQuality(newValue);
  // };
  // const handleSliderforDiscolourArea = (event, newValue) => {
  //   setdiscolorArea(newValue);
  // };
  // const handleSliderforDiscolourQuality = (event, newValue) => {
  //   setdiscolorQuality(newValue);
  // };
  const handleSliderforChalkyAreaForVariety = (event, newValue) => {
    setchalkyAreaForVariety(newValue);
  };
  const handleSliderForChalkyQualityForVariety = (event, newValue) => {
    setchalkyQualityForVariety(newValue);
  };
  const handleSliderforDiscolourAreaForVariety = (event, newValue) => {
    setdiscolorAreaForVariety(newValue);
  };
  const handleSliderforDiscolourQualityForVariety = (event, newValue) => {
    setdiscolorQualityForVariety(newValue);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [cropResponse, machineResponce, userMetaDataResponce] = await Promise.all([
          getCropsAndVarieties(company_id),
          getAllMachine(company_id),
          getCompanyMetaData(company_id),
        ])

        if (cropResponse?.data?.data) {
          setCrops(cropResponse?.data?.data);
          const crop_list = cropResponse?.data?.data
          const uniqueObjects = crop_list?.length && crop_list.reduce((unique, currentObj) => {
            const isDuplicate = unique.some(obj => obj.crop_name === currentObj.crop_name)
            if (!isDuplicate) { unique.push(currentObj) }
            return unique;
          }, []);
          setUniqueCropList(uniqueObjects);
        } else {
          onHandleResponceError(cropResponse?.status, cropResponse?.data?.message)
        }
        if (machineResponce?.data?.data) {
          setMachines(machineResponce.data.data);
        } else {
          onHandleResponceError(machineResponce?.status, machineResponce?.data?.message)
        }
        if (userMetaDataResponce?.data?.data) {
          setGetUserMetaData(userMetaDataResponce.data.data);
        } else {
          onHandleResponceError(userMetaDataResponce?.response?.status, userMetaDataResponce?.response?.data?.message)
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [])

  useEffect(() => {
    if (selectedCrop) {
      const verity_list = crops.length && crops.filter(crop => (
        crop.crop_name === selectedCrop.crop_name
      ))

      setVarietyListRelatedCrop(verity_list);
      setSelectedVariety('')
      setSelectedValues({})
      handleRefreshClick()
    } else {
      setVarietyListRelatedCrop([]);
    }
  }, [selectedCrop])

  const fetchVarietyListRelatedCrop = async () => {
    try {
      if (selectedCrop) {
        const response = await getCropsAndVarieties()
        if (response?.data?.data) {
          setCrops(response?.data?.data);
          const crop_list = response?.data?.data
          const uniqueObjects = crop_list?.length && crop_list.reduce((unique, currentObj) => {
            const isDuplicate = unique.some(obj => obj.crop_name === currentObj.crop_name)
            if (!isDuplicate) { unique.push(currentObj) }
            return unique;
          }, []);
          setUniqueCropList(uniqueObjects);
          const varietyList = response.data.data;
          const varietyListRelatedCrop = crops.length && varietyList.filter(variety => variety.crop_name === selectedCrop.crop_name);
          setVarietyListRelatedCrop(varietyListRelatedCrop);
          setSelectedVariety('')
        }
      } else {
        setVarietyListRelatedCrop([]);
      }
    } catch (error) {
      console.error('Error fetching variety list:', error);
    }
  };

  useEffect(() => {
    const fetchConfigurations = async () => {
      if (selectedMachine && selectedVariety) {
        try {
          await onGetRequestConfigurations(selectedVariety.id, selectedMachine.machine_code);
        } catch (error) {
          console.error('Error fetching configurations:', error);
        }
      }
    };

    fetchConfigurations();
  }, [selectedVariety, selectedMachine]);

  const onHandleResponceError = (code, message) => {
    message && setIsErrorOpen(true)

    if (code === 404) {
      message = 'Error bad request or wrong url'
    }
    setTitle('Alert')
    SetMessage(message)
  }

  const onGetRequestConfigurations = async (selectedCropId, selectedMachineId) => {
    try {
      setIsLoadingRequestConfigurations(true)
      const response = (selectedCropId && selectedMachineId) && await getRequestConfigurations(selectedCropId, selectedMachineId)
      setRequestConfigurations(response?.data?.data?.requestConfigurations)
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingRequestConfigurations(false)
    }
  }

  const handleFileChange = async (event) => {
    setScanData(null);
    setProcessedImage([]);
    setProcessedImageBottom(null);
    setSelectedCapturedWebpImage([]);
    setSelectedCapturedWebpImageBottom(null);
    setSelectedLedTopImage(null);
    setSelectedLedBottomImage(null);
    if (ledTopFileInputRef.current) ledTopFileInputRef.current.value = '';
    if (ledBottomFileInputRef.current) ledBottomFileInputRef.current.value = '';

    const files = Array.from(event.target.files);
    if (!files.length) return;

    if (files.length > 5) {
      alert('Please select up to 5 files only.');
      event.target.value = '';
      return;
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const extension = file.name.split('.').pop().toLowerCase();

      if (!allowedExtensions.includes(extension)) {
        alert(`"${file.name}" is not a valid image file. Allowed: ${allowedExtensions.join(', ')}`);
        event.target.value = '';
        return;
      }

      if (file.size > 100 * 1024 * 1024) {
        alert(`"${file.name}" exceeds 100MB. Please upload a smaller file.`);
        event.target.value = '';
        return;
      }
    }

    const renamedFiles = files.map(file => {
      const extension = file.name.split('.').pop();
      return new File([file], `captured.${extension}`, { type: file.type });
    });

    setSelectedCapturedWebpImage(renamedFiles);
  };

  const handleBottomFileChange = async (event) => {
    setScanData(null);
    setProcessedImageBottom(null);
    setSelectedCapturedWebpImageBottom(null);
    setMoisture('');
    setWeight('');

    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const extension = selectedFile.name.split('.').pop().toLowerCase();

      if (!allowedExtensions.includes(extension)) {
        alert(`"${selectedFile.name}" is not a valid image file. Allowed: ${allowedExtensions.join(', ')}`);
        event.target.value = '';
        return;
      }

      if (selectedFile.size > 100 * 1024 * 1024) {
        alert(`"${selectedFile.name}" exceeds 100MB. Please upload a smaller file.`);
        event.target.value = '';
        return;
      }

      const renamedFile = new File([selectedFile], `captured_bottom.${extension}`, { type: selectedFile.type });
      setSelectedCapturedWebpImageBottom(renamedFile);
    }
  };
  const handleSubmitClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    if (bottomFileInputRef.current) {
      bottomFileInputRef.current.value = '';
    }
    if (ledTopFileInputRef.current) {
      ledTopFileInputRef.current.value = '';
    }
    if (ledBottomFileInputRef.current) {
      ledBottomFileInputRef.current.value = '';
    }
    setVisiblePdfButton(false)
    setScanData(null)
    setIsProcessing(true)
    setIsCvInferenceResponce(false)
    setIsMetaDataServerResponce(false)
  }

  const saveTestVariety = async () => {
    setTitle('')
    SetMessage('')
    setIsMessageOpen(true)
    setIsLoading(true)
    const crop_name = selectedCrop?.crop;
    const variety_name = selectedVariety?.variety
    const companyid = localStorage.getItem('company_id');
    const firstOccurrenceIndex = variety_name.indexOf("_a");
    let processed_variety_name = firstOccurrenceIndex !== -1
      ? variety_name.substring(0, firstOccurrenceIndex)
      : variety_name;
    const newVarietyName = `${processed_variety_name}_a${chalkyArea}_b${chalkyQuality}_c${discolorArea}_d${discolorQuality}`;
    try {
      const response = await AddCustomVarietes(crop_name, variety_name, companyid, newVarietyName);
      if (response.status === 200) {
        fetchVarietyListRelatedCrop()
        setTitle('Sucess')
        SetMessage(response?.data?.message)
      }
      if (response.status === 400) {
        setTitle('Alert')
        SetMessage(response?.data?.message)
      }
      setIsLoading(false)
    } catch (error) {
      console.error('Error:', error);
    }
  }

  function getVarietyCode(crop, variety) {
    const pm = {
      cropType: crop,
      cropVariety: variety,
    };
    if (pm.cropType === 'Rice' && pm.cropVariety.includes('Perfect')) return 'v0';
    else if (pm.cropType === 'Rice' && pm.cropVariety === 'IR8') return 'v1';
    else if (pm.cropType === 'Rice' && pm.cropVariety === 'gujrati') return 'v2';
    else if (pm.cropType === 'Rice' && pm.cropVariety === 'gujarat') return 'v2';
    else if (pm.cropType === 'Rice' && pm.cropVariety === 'tukdi') return 'v3';
    else if (pm.cropType === 'Rice' && pm.cropVariety === 'sella') return 'v4';
    else if (pm.cropType === 'Rice' && pm.cropVariety === 'steam') return 'v5';
    else if (pm.cropType === 'Rice' && pm.cropVariety === 'hybrid') return 'v6';
    else if (pm.cropType === 'Rice' && pm.cropVariety === 'basmati') return 'v7';
    else if (pm.cropType === 'Rice' && pm.cropVariety === 'gujrati_boiled') return 'v8';
    else if (pm.cropType === 'Rice' && pm.cropVariety === 'delight_basmati') return 'v9';
    else if (pm.cropType === 'Rice' && pm.cropVariety === 'raj_rani') return 'v10';
    else if (pm.cropType === 'Rice' && pm.cropVariety === 'IR64') return 'v11';
    else if (pm.cropType === 'Rice' && pm.cropVariety === 'IR64_boiled') return 'v12';
    else if (pm.cropType === 'Rice' && pm.cropVariety === 'bori_basmati') return 'v13';
    else if (pm.cropType === 'Rice' && pm.cropVariety === 'sriram') return 'v14';
    else if (pm.cropType === 'Arhar' && pm.cropVariety === 'default') return 'v1';
    else if (pm.cropType === 'Arhar' && pm.cropVariety === 'white') return 'v2';
    else if (pm.cropType === 'Arhar' && pm.cropVariety === 'split_arhar') return 'v3';
    else if (pm.cropType === 'Urad' && pm.cropVariety === 'default') return 'v1';
    else if (pm.cropType === 'Urad' && pm.cropVariety === 'brown') return 'v2';
    return 'v1';
  }

  const onCallInferenceServer = async () => {
    try {
      const scan_id = generateTimeBasedUniqueScanId(user_id);
      setScanId(scan_id);
      const crop_name = selectedVariety?.crop_name || '';
      const lowercase_crop_name = crop_name.toLowerCase();
      const variety_code = getVarietyCode(selectedVariety?.crop_name, selectedVariety?.variety_name);
      const lowercase_crop_variety_name = selectedVariety?.variety_name?.toLowerCase() || '';
      const firstOccurrenceIndex = lowercase_crop_variety_name.indexOf('_a');
      const processed_variety_name =
        firstOccurrenceIndex !== -1
          ? lowercase_crop_variety_name.substring(0, firstOccurrenceIndex)
          : lowercase_crop_variety_name;

      const locationId = localStorage.getItem('location_id') || null;

      const machineInstanceIdMap = {
        M2: 'WebScanner-Easy',
        M3: 'WebScanner-Ultra',
        M4: 'WebScanner-Easy360',
      };

      let threshold_value = getThresholdValues(selectedVariety?.variety_name);

      threshold_value = threshold_value || {
        discolor_quality: discolorQuality / 100,
        discolor_area: discolorArea / 100,
        chalky_quality: chalkyQuality / 100,
        chalky_area: chalkyArea / 100,
      };

      const inferencePromises = selectedCapturedWebpImage.map((file, i) =>
        sendInferenceRequest({
          image: file,
          ...(selectedMachine.machine_code === 'M4' && {
            image_bottom: selectedCapturedWebpImageBottom,
          }),
          ...(selectedMachine.machine_code === 'M4' && isMultiCapture && selectedLedTopImage && selectedLedBottomImage && {
            shadow_image: selectedLedTopImage,
            shadow_bottom_image: selectedLedBottomImage,
          }),
          machineType: selectedMachine.machine_code,
          coin_radius: selectedMachine.coin_radius,
          coin_radius_bottom: selectedMachine.coin_radius_bottom,
          cropType: lowercase_crop_name,
          companyId: company_id,
          moistureValue: moisture,
          weightValue: weight,
          locationId: locationId,
          scanId: scan_id,
          subScanId: i + 1,
          cropID: selectedVariety?.crop_id,
          varietyID: selectedVariety?.variety_id,
          machineID: selectedMachine.machine_id,
          machineInstanceId: machineInstanceIdMap[selectedMachine.machine_code],
          user_id,
          updatedUserMetaData,
          reqConfigValues:
            lowercase_crop_name === 'rice' && selectedMachine?.machine_code === 'M3'
              ? threshold_value
              : null,
          ...(lowercase_crop_name === 'rice' && {
            variety_code,
            processed_variety_name,
          }),
        }).then(async (res) => {
          const status = res?.status;
          const data = res?.data;
          return { status, data, index: i };
        }).catch((err) => ({ error: err, index: i }))
      );

      const results = await Promise.all(inferencePromises);

      let processedImages = [];
      let bottomImageSet = false;
      let successfulResults = [];
      const failedScanErrors = [];

      for (const result of results) {
        if (result.error || !result.data) {
          console.error('Error in inference:', result.error);
          const status = result?.error?.response?.status;
          const serverMessage =
            status === 502
              ? 'Server is shutdown or restarting. Please try again after 10 minutes or between 8 AM to 8 PM.'
              : status === 503
                ? 'Server is restarting. Please try again after 10 to 15 minutes.'
                : result?.error?.response?.data?.message ||
                result?.error?.message ||
                'Server is currently under maintenance. Please contact the support team for assistance.';

          failedScanErrors.push(`**Sub-Scan ${result.index + 1}**: ${serverMessage}`);
          continue;
        }

        const { status, data } = result;
        let parsedData = typeof data === "string" ? JSON.parse(data) : data;
        if (status === 200) {
          setIsCvInferenceResponce(true);
          const { segment_image } = parsedData;
          if (selectedMachine?.machine_code === 'M4') {
            if (segment_image?.top_image) {
              processedImages.push(`data:image/jpeg;base64,${segment_image?.top_image}`);
            }

            if (!bottomImageSet && segment_image?.image) {
              setProcessedImageBottom(`data:image/jpeg;base64,${segment_image.image}`);
              bottomImageSet = true;
            }
          } else {
            if (segment_image.image) {
              processedImages.push(`data:image/jpeg;base64,${segment_image.image}`);
            }
          }
          parsedData.success = true;
          successfulResults.push(parsedData);
          setVisiblePdfButton(true);

          if (parsedData?.alerts?.alert_keys?.length > 0) {
            let warningMessage = '';
            parsedData.alerts.alert_keys.forEach((alert) => {
              warningMessage += parsedData.alerts.alert_messages[alert]?.message + '\n';
            });
            setTitle('Warning');
            SetMessage(warningMessage);
            setIsErrorOpen(true);
          }
        } else {
          failedScanErrors.push(`**Sub-Scan ${result.index + 1}** : ${parsedData?.reason || parsedData?.message}`);
        }
      }

      if (successfulResults.length > 0) {
        const mergedResult = GetScanResultMerged(successfulResults, weight, moisture);
        setScanData(mergedResult);
      } else {
        setTitle('Alert');
        SetMessage(failedScanErrors.join('\n'));
        setIsErrorOpen(true);
        setSelectedCapturedWebpImage(null);
        setSelectedCapturedWebpImageBottom(null);
        setSelectedLedTopImage(null);
        setSelectedLedBottomImage(null);
      }

      setTotalSubScan(successfulResults.length);
      setProcessedImage(processedImages);
      setIsProcessing(false);
      setMoisture('');
      setWeight('');
    } catch (error) {
      console.error(error);
      onHandleResponceError(500, 'Internal Server Error, please contact the admin');
      setIsProcessing(false);
    }
  };

  const handleLedTopFileChange = async (event) => {
    setSelectedLedTopImage(null);
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const extension = selectedFile.name.split('.').pop().toLowerCase();
      if (!allowedExtensions.includes(extension)) {
        alert(`Not a valid image file.`);
        event.target.value = '';
        return;
      }
      const renamedFile = new File([selectedFile], `captured_led.${extension}`, { type: selectedFile.type });
      setSelectedLedTopImage(renamedFile);
    }
  };

  const handleLedBottomFileChange = async (event) => {
    setSelectedLedBottomImage(null);
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const extension = selectedFile.name.split('.').pop().toLowerCase();
      if (!allowedExtensions.includes(extension)) {
        alert(`Not a valid image file.`);
        event.target.value = '';
        return;
      }
      const renamedFile = new File([selectedFile], `captured_bottom_led.${extension}`, { type: selectedFile.type });
      setSelectedLedBottomImage(renamedFile);
    }
  };

  const handleCloseForVariety = () => {
    setModalOpen(false)
    setPoniyaThreshold('')
    setHeightOfKernel('')
    setBrokenThreshold('')
    setAddThreshold(false)
    setchalkyAreaForVariety(50);
    setdiscolorAreaForVariety(10);
    setchalkyQualityForVariety(50);
    setdiscolorQualityForVariety(20)
  };

  const handleSave = async () => {
    if (heightOfKernel === '' || poniyaThreshold === '' || brokenThreshold === '') {
      alert('Please fill in all required fields.');
      return;
    }
    handleCloseForVariety()
    setTitle('')
    SetMessage('')
    setIsMessageOpen(true)
    setIsLoading(true)
    const crop_name = selectedCrop?.crop;
    let variety_name;
    const hasDecimalPoint = String(heightOfKernel).includes('.');
    const heightFloat = hasDecimalPoint ? heightOfKernel : heightOfKernel + '.0';
    const formattedPoniyaThreshold = String(poniyaThreshold).replace(/^0+/, '').padStart(2, '0');
    const formattedBrokenThreshold = String(brokenThreshold).replace(/^0+/, '').padStart(2, '0');

    if (addThreshold) {
      variety_name = `Perfect${heightFloat}mm_P${formattedPoniyaThreshold}_B${formattedBrokenThreshold}_a${chalkyAreaForVariety}_b${chalkyQualityForVariety}_c${discolorAreaForVariety}_d${discolorQualityForVariety}`;
    } else {
      variety_name = `Perfect${heightFloat}mm_P${formattedPoniyaThreshold}_B${formattedBrokenThreshold}`;
    }

    const companyid = localStorage.getItem('company_id');
    try {
      const response = await AddCustomVarietes(crop_name, variety_name, companyid);
      if (response.status === 200) {
        fetchVarietyListRelatedCrop()
        setTitle('Success')
        SetMessage(response?.data?.message)
      }
      if (response.status === 400) {
        setTitle('Alert')
        SetMessage(response?.data?.message)
      }
      setIsLoading(false)
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleRefreshClick = async () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    if (bottomFileInputRef.current) {
      bottomFileInputRef.current.value = '';
    }
    if (ledTopFileInputRef.current) ledTopFileInputRef.current.value = '';
    if (ledBottomFileInputRef.current) ledBottomFileInputRef.current.value = '';
    setVisiblePdfButton(false)
    setMoisture('')
    setWeight('')
    setScanId(null)
    setTotalSubScan(null)
    setProcessedImage([])
    setProcessedImageBottom(null)
    setScanData(null)
    setSelectedCapturedWebpImage([])
    setSelectedCapturedWebpImageBottom(null)
    setChecked(false)
    setSelectedLedTopImage(null)
    setSelectedLedBottomImage(null)
  };

  const isM4 = selectedMachine?.machine_code === 'M4';

  const isDisabled = !(
    selectedCrop &&
    selectedVariety &&
    selectedMachine &&
    selectedCapturedWebpImage?.length > 0 &&
    (!isM4 || selectedCapturedWebpImageBottom) &&
    (!isM4 || !isMultiCapture || (selectedLedTopImage && selectedLedBottomImage))
  ) || (scanData && Object.keys(scanData)?.length > 0);

  return (
    <Box sx={{ p: { xs: 2, md: 0 } }}>
      <WeightAndMoisture
        open={isAddMoistureAndWeight}
        setOpen={setIsAddMoistureAndWeight}
        weight={weight}
        setWeight={setWeight}
        moisture={moisture}
        setMoisture={setMoisture}
      />

      <PopUpMessage
        open={isErrorOpen}
        setOpen={setIsErrorOpen}
        title={title}
        message={message}
      />
      <PopUpMessage
        open={isMessageOpen}
        title={title}
        isLoading={isLoading}
        setOpen={setIsMessageOpen}
        message={message}
      />
      <ProcessingForm
        isProcessing={isProcessing}
        isCvInferenceResponce={isCvInferenceResponce}
        getUserMetaData={getUserMetaData}
        isMetaDataServerResponce={isMetaDataServerResponce}
        setUpdatedUserMetaData={setUpdatedUserMetaData}
        setIsProcessing={setIsProcessing}
        onCancleClick={handleRefreshClick}
        onCallInferenceServer={onCallInferenceServer}
        cropname={selectedCrop}
      />

      <Box sx={{ ...cardShell, backgroundColor: '#fff', p: 2.5 }}>

        {/* Single unified row — Crop/Variety/Machine/Upload(Top), then M4 fields inline if M4, then buttons */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            rowGap: 4,
            columnGap: 2,
            alignItems: 'flex-end',
          }}
        >
          <Box sx={{ width: { xs: '100%', sm: 'calc(50% - 8px)', lg: 180 } }}>
            <DropDown label="Crop" multiple={false} required fullWidth options={uniqueCropList} getKey={(o) => o.crop_id} getLabel={(o) => o.crop_name} selectedKeys={selectedCrop?.crop_id || ''} onChange={setSelectedCrop} />
          </Box>

          <Box sx={{ width: { xs: '100%', sm: 'calc(50% - 8px)', lg: 180 } }}>
            <DropDown label="Variety" multiple={false} required fullWidth options={verietyListRelatedCrop} getKey={(o) => o.variety_id} getLabel={(o) => o.variety_name} getGroupLabel={(o) => (o.variety_name?.includes('_a') ? 'Custom Threshold' : 'Default')} selectedKeys={selectedVariety?.variety_id || ''} onChange={setSelectedVariety} />
          </Box>

          <Box sx={{ width: { xs: '100%', sm: 'calc(50% - 8px)', lg: 180 } }}>
            <DropDown label="Machine" multiple={false} required fullWidth options={machines} getKey={(o) => o.machine_code} getLabel={(o) => `${o.machine_name} - ${o.machine_code}`} selectedKeys={selectedMachine?.machine_code || ''} onChange={setSelectedMachine} />
          </Box>

          <Box sx={{ width: { xs: '100%', sm: 'calc(50% - 8px)', lg: 190 } }}>
            <FileField
              label={selectedMachine?.machine_code === 'M4' ? 'Upload File (Top)' : 'Upload File'}
              required
              multiple
              fullWidth
              inputRef={fileInputRef}
              onChange={handleFileChange}
            />
          </Box>

          {/* M4 extra fields — inline in the SAME row, no separate boxed second row */}
          {selectedMachine?.machine_code === 'M4' && (
            <>
              <Box sx={{ width: { xs: '100%', sm: 'calc(50% - 8px)', lg: 190 } }}>
                <FileField label="Upload File (Bottom)" required fullWidth inputRef={bottomFileInputRef} onChange={handleBottomFileChange} />
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', height: 40, width: { xs: '100%', sm: 'auto' } }}>
                <input
                  type="checkbox"
                  id="multiCapture"
                  checked={isMultiCapture}
                  style={{ width: 18, height: 18, cursor: 'pointer', accentColor: ACCENT_BLUE }}
                  onChange={(e) => {
                    setIsMultiCapture(e.target.checked);
                    if (!e.target.checked) {
                      setSelectedLedTopImage(null);
                      setSelectedLedBottomImage(null);
                      if (ledTopFileInputRef.current) ledTopFileInputRef.current.value = '';
                      if (ledBottomFileInputRef.current) ledBottomFileInputRef.current.value = '';
                    }
                  }}
                />
                <label htmlFor="multiCapture" style={{ cursor: 'pointer', fontWeight: 600, fontSize: 13, color: TEXT_BODY, whiteSpace: 'nowrap' }}>
                  Multi Capture (LED)
                </label>
              </Box>

              {isMultiCapture && (
                <Box sx={{ width: { xs: '100%', sm: 'calc(50% - 8px)', lg: 190 } }}>
                  <FileField label="Upload File (Top Bottom LED)" required fullWidth inputRef={ledTopFileInputRef} onChange={handleLedTopFileChange} />
                </Box>
              )}

              {isMultiCapture && (
                <Box sx={{ width: { xs: '100%', sm: 'calc(50% - 8px)', lg: 190 } }}>
                  <FileField label="Upload File (Bottom Top LED)" required fullWidth inputRef={ledBottomFileInputRef} onChange={handleLedBottomFileChange} />
                </Box>
              )}
            </>
          )}

          <Tooltip title="Add Weight & Moisture" arrow
            slotProps={{
              tooltip: {
                sx: {
                  padding: '8px 12px',
                  borderRadius: '8px',
                },
              },
            }}>
            <Button
              variant="contained"
              onClick={() => setIsAddMoistureAndWeight(true)}
              startIcon={<ScaleIcon sx={{ fontSize: 16 }} />}
              sx={{
                backgroundColor: ACCENT_ORANGE,
                borderRadius: '10px',
                textTransform: 'none',
                fontWeight: 600,
                boxShadow: 'none',
                px: 2,
                height: 40,
                whiteSpace: 'nowrap',
                width: { xs: '100%', sm: 'auto' },
                '&:hover': { backgroundColor: '#c25f34', boxShadow: 'none' },
              }}
            >
              W/M
            </Button>
          </Tooltip>

          <Button
            variant="contained"
            onClick={handleSubmitClick}
            disabled={isDisabled}
            sx={{
              backgroundColor: ACCENT_BLUE,
              borderRadius: '10px',
              textTransform: 'none',
              boxShadow: 'none',
              px: 3,
              height: 40,
              width: { xs: '100%', sm: 'auto' },
              '&:hover': { backgroundColor: '#1b4f73', boxShadow: 'none' },
            }}
          >
            Submit
          </Button>

          <IconButton
            aria-label="Reset"
            title="Reset"
            onClick={handleRefreshClick}
            sx={{
              height: 40,
              width: { xs: '100%', sm: 40 },
              borderRadius: '10px',
              border: '1px solid #e57373',
              color: '#d32f2f',
              '&:hover': { borderColor: '#d32f2f', backgroundColor: '#fdeceb' },
            }}
          >
            <RefreshIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>

        {isModalOpen &&
          <AddCustomVariety
            open={isModalOpen}
            setOpen={setModalOpen}
            handleSave={handleSave}
            handleClose={handleCloseForVariety}
            heightOfKernel={heightOfKernel}
            setHeightOfKernel={setHeightOfKernel}
            PoniyaThreshold={poniyaThreshold}
            setPoniyaThreshold={setPoniyaThreshold}
            brokenThreshold={brokenThreshold}
            setBrokenThreshold={setBrokenThreshold}
            selectedCrop={selectedCrop}
            handleCheckboxChange={handleCheckboxChange}
            addThreshold={addThreshold}
            setAddThreshold={setAddThreshold}
            chalkyAreaForVariety={chalkyAreaForVariety}
            discolorAreaForVariety={discolorAreaForVariety}
            chalkyQualityForVariety={chalkyQualityForVariety}
            discolorQualityForVariety={discolorQualityForVariety}
            resetSliders={resetSliders}
            handleSliderforChalkyAreaForVariety={handleSliderforChalkyAreaForVariety}
            handleSliderForChalkyQualityForVariety={handleSliderForChalkyQualityForVariety}
            handleSliderforDiscolourAreaForVariety={handleSliderforDiscolourAreaForVariety}
            handleSliderforDiscolourQualityForVariety={handleSliderforDiscolourQualityForVariety}
          />}

        {/* <Box sx={{ marginTop: 3 }}>
          {selectedCrop?.crop_name === 'Rice' && !variety_list_static_threshold.includes(selectedCrop?.variety_name) && selectedMachine?.machine_code === 'M3' && selectedVariety && (
            <>
              <div style={{ display: "flex", gap: "20px" }}>
                <div>
                  <div>
                    <label style={{ color: TEXT_BODY }}><strong>Chalky threshold</strong></label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px' }}>
                    <span style={{ marginRight: '10px', color: TEXT_MUTED, fontSize: 13 }}>Area %</span>
                    <Slider
                      value={chalkyArea}
                      onChange={handleSliderforChalkyArea}
                      aria-label="Slider 1"
                      valueLabelDisplay="on"
                      valueLabelFormat={(value) => <span>{value}%</span>}
                      min={0}
                      max={100}
                      sx={{ width: '200px', color: ACCENT_BLUE }}
                    />
                  </div>
                </div>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '45px' }}>
                    <span style={{ marginRight: '10px', color: TEXT_MUTED, fontSize: 13 }}>Quality %</span>
                    <Slider
                      value={chalkyQuality}
                      onChange={handleSliderForChalkyQuality}
                      aria-label="Slider 2"
                      valueLabelDisplay="on"
                      valueLabelFormat={(value) => <span>{value}%</span>}
                      min={0}
                      max={100}
                      sx={{ width: '200px', color: ACCENT_BLUE }}
                    />
                    <Button aria-label="Information" onClick={handleButtonClick} sx={{ color: ACCENT_BLUE }}>
                      <InfoIcon />
                    </Button>
                    <Popover
                      open={openChalky}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                    >
                      <Paper style={{ padding: '10px', maxWidth: '300px' }}>
                        <Typography>
                          If selected or larger area comes in one kernel, then consider it as chalky.
                        </Typography>
                      </Paper>
                    </Popover>
                  </div>
                </div>
                <div style={{ alignItems: 'center', marginTop: '45px' }}>
                  <Button
                    variant="contained"
                    onClick={resetSliders}
                    sx={{ backgroundColor: ACCENT_BLUE, borderRadius: '10px', textTransform: 'none', boxShadow: 'none', '&:hover': { backgroundColor: '#1b4f73', boxShadow: 'none' } }}
                  >
                    Reset
                  </Button>
                </div>
              </div>
              <div style={{ display: "flex", gap: "20px", marginTop: '20px' }}>
                <div>
                  <div>
                    <label style={{ color: TEXT_BODY }}><strong>Discolour threshold</strong></label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px' }}>
                    <span style={{ marginRight: '10px', color: TEXT_MUTED, fontSize: 13 }}>Area %</span>
                    <Slider
                      value={discolorArea}
                      onChange={handleSliderforDiscolourArea}
                      aria-label="Slider 1"
                      valueLabelDisplay="on"
                      valueLabelFormat={(value) => <span>{value}%</span>}
                      min={0}
                      max={100}
                      sx={{ width: '200px', color: ACCENT_BLUE }}
                    />
                  </div>
                </div>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '45px' }}>
                    <span style={{ marginRight: '10px', color: TEXT_MUTED, fontSize: 13 }}>Quality %</span>
                    <Slider
                      value={discolorQuality}
                      onChange={handleSliderforDiscolourQuality}
                      aria-label="Slider 2"
                      valueLabelDisplay="on"
                      valueLabelFormat={(value) => <span>{value}%</span>}
                      min={0}
                      max={100}
                      sx={{ width: '200px', color: ACCENT_BLUE }}
                    />
                    <Button aria-label="Information" onClick={handleButtonClickForDiscolor} sx={{ color: ACCENT_BLUE }}>
                      <InfoIcon />
                    </Button>
                    <Popover
                      open={openDiscolor}
                      anchorEl={anchorForDiscolor}
                      onClose={handleCloseForDiscolor}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                    >
                      <Paper style={{ padding: '10px', maxWidth: '300px' }}>
                        <Typography>
                          If selected or larger area comes in one kernel, then consider it as discolour.
                        </Typography>
                      </Paper>
                    </Popover>
                  </div>
                </div>
              </div>
            </>
          )}
        </Box> */}

        <Box display="flex" alignItems="center" gap={4} mb={2} mt={4} flexWrap="wrap">
          {!isLoadingRequestConfigurations ? <>
            {selectedMachine.machine_code === 'M2' && requestConfigurations && requestConfigurations.length > 0 &&
              requestConfigurations.map((config) => (
                <Box key={config._id} width="20%" minWidth={180}>
                  <Typography variant="subtitle1" sx={{ textAlign: 'start', margin: 1, color: TEXT_BODY, fontSize: 13.5, fontWeight: 600 }}>
                    {config.display_name}<span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <FormControl size="small" fullWidth>
                    <InputLabel>{config.display_name}</InputLabel>
                    <Select
                      value={selectedValues[config.key_name] || ""}
                      onChange={(e) => handleSelectChange(config.key_name, e.target.value)}
                      label={config.display_name}
                      sx={{ borderRadius: '10px', backgroundColor: '#fff' }}
                    >
                      <MenuItem value="" disabled>Select an option</MenuItem>
                      {config.values.map((value, i) => (
                        <MenuItem key={i} value={value}>
                          {value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              ))}
          </> : <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 1.5 }}><CircularProgress size={30} sx={{ color: ACCENT_BLUE }} /></Box>}
        </Box>
      </Box>

      <Box sx={{ mt: 3 }}>
        {scanData && <ResultScreen
          scanId={scanId}
          totalSubScan={totalSubScan}
          cropList={crops}
          cropId={selectedVariety.id}
          scanResult={scanData}
          moisture={moisture}
          weight={weight}
          visiblePDfButton={visiblePDfButton}
          isChecked={isChecked}
          saveTestVariety={saveTestVariety}
        />}

        <div className='align-center'>{selectedCapturedWebpImage?.length > 0 && <h4 className='m-t-20' style={{ color: TEXT_BODY }}>Preview Image</h4>}</div>

        <div>
          <div className='d-flex justify-center align-center m-t-10 g-20'>
            {processedImage?.length > 0 && (
              <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                {processedImage.map((img, idx) => (
                  <div key={idx} className='m-b-10'>
                    <img
                      src={img}
                      alt={`Processed ${selectedMachine?.machine_code === 'M4' ? 'Top ' : ''}${idx + 1}`}
                      height="400"
                      width={300}
                      style={{ borderRadius: 12, border: `1px solid ${BORDER}` }}
                    />
                    <p className='text-align-center' style={{ color: TEXT_BODY }}>
                      <b>
                        <u>
                          Processed Image
                          {selectedMachine?.machine_code === 'M4' ? ' (Top' : ''}
                          {processedImage.length > 1 ? ` -${idx + 1}` : ''}
                          {selectedMachine?.machine_code === 'M4' ? ')' : ''}
                        </u>
                      </b>
                    </p>
                  </div>
                ))}
              </div>
            )}

            {processedImageBottom && (
              <div>
                <img
                  src={processedImageBottom}
                  alt="Processed Bottom"
                  height="400"
                  width={300}
                  style={{ borderRadius: 12, border: `1px solid ${BORDER}` }}
                />
                <p className='text-align-center' style={{ color: TEXT_BODY }}>
                  <b><u>Processed Image (Bottom)</u></b>
                </p>
              </div>
            )}
          </div>

          <div className='d-flex justify-center align-center m-t-10 g-20'>
            {selectedCapturedWebpImage?.length > 0 && (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                {selectedCapturedWebpImage.map((topImage, index) => (
                  <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <img
                      src={URL.createObjectURL(topImage)}
                      alt={`Original ${selectedMachine?.machine_code === 'M4' ? 'Top ' : ''}${index + 1}`}
                      height="400"
                      width={300}
                      style={{ borderRadius: 12, border: `1px solid ${BORDER}` }}
                    />
                    <p className='align-center' style={{ color: TEXT_BODY }}>
                      <b>
                        <u>
                          Original Image
                          {selectedMachine?.machine_code === 'M4' ? ' (Top' : ''}
                          {selectedCapturedWebpImage.length > 1 ? ` -${index + 1}` : ''}
                          {selectedMachine?.machine_code === 'M4' ? ')' : ''}
                        </u>
                      </b>
                    </p>
                  </div>
                ))}
              </div>
            )}

            {selectedCapturedWebpImageBottom && (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img
                  src={URL.createObjectURL(selectedCapturedWebpImageBottom)}
                  alt="Original Bottom"
                  height="400"
                  width={300}
                  style={{ borderRadius: 12, border: `1px solid ${BORDER}` }}
                />
                <p className='align-center' style={{ color: TEXT_BODY }}>
                  <b><u>Original Image (Bottom)</u></b>
                </p>
              </div>
            )}

            {isMultiCapture && (selectedLedTopImage || selectedLedBottomImage) && (
              <div className='d-flex justify-center align-center g-20'>
                {selectedLedTopImage && (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <img
                      src={URL.createObjectURL(selectedLedTopImage)}
                      alt="LED Top"
                      height="400"
                      width={300}
                      style={{ borderRadius: 12, border: `1px solid ${BORDER}` }}
                    />
                    <p className='align-center' style={{ color: TEXT_BODY }}>
                      <b><u>Original Image (Top Bottom LED)</u></b>
                    </p>
                  </div>
                )}

                {selectedLedBottomImage && (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <img
                      src={URL.createObjectURL(selectedLedBottomImage)}
                      alt="LED Bottom"
                      height="400"
                      width={300}
                      style={{ borderRadius: 12, border: `1px solid ${BORDER}` }}
                    />
                    <p className='align-center' style={{ color: TEXT_BODY }}>
                      <b><u>Original Image (Bottom Top LED)</u></b>
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </Box>
    </Box>
  )
}